const SECTION_TYPE = [
    'banner',
    'category',
    'offer',
    'banners',
];

export default SECTION_TYPE